import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const settingsApi = createApi({
    reducerPath: "settingsApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Settings", "Profile"],
    endpoints: (builder) => ({
        getSettings: builder.query({
            query: () => ({
                url: `/admin/settings`,
                method: "GET",
            }),
        }),
        addSettings: builder.mutation({
            query: (data) => ({
                url: `/admin/settings`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Settings"],
        }),
        updateSettings: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/settings/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Settings"],
        }),
        getContactUs: builder.query({
            query: ({ pageno, search, status, type ,sortBy , sortOrder, limit}) => {
                let url = `/admin/contactus?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (type) {
                    url += `&type=${type}`;
                }
                if(sortBy){
                    url += `&sortBy=${sortBy}`;
                }
                if(sortOrder){
                    url += `&sortOrder=${sortOrder}`;
                }
                if(limit){
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ['Settings'],
        }),
        replyContactUsQuery: builder.mutation({
            query: ({ data, id }) => ({
                url: `/admin/contactus/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings'],
        }),
        changePassword: builder.mutation({
            query: ({ role, data }) => {
              let url = role === "admin" ? `/${role}/password` : `/${role}/change_password`;    
              return {
                url,
                method: "PUT",
                body: data,
              };
            },
          }),
        updateProfile: builder.mutation({
            query: ({ role, data }) => ({
                url: `/${role}/profile`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings', 'Profile'],
        }),
        deleteAccount: builder.mutation({
            query: ({ role, data }) => ({
                url: `/${role}/account`,
                method: "DELETE",
                body: data,
            }),
        }),
        getNotifications: builder.query({
            query: ({ url, pageno }) => {
                 url = url + `?pageno=${pageno}`;
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ['Settings'], 
        }),
        notificationMarkAsRead: builder.mutation({
            query: ({ data ,role}) => ({
                url: `/${role}/notifications/read`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings'],
        }),

        getUserProfile: builder.query({
            query: ({ role }) => ({
                url: `/${role}/profile`,
                method: "GET",
            }),
            providesTags: ['Profile'],
        }),
        updateCompany: builder.mutation({
            query: ({ role, data }) => ({
                url: `/${role}/company`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Settings', 'Profile'],
        }),
        updateSupportStatus: builder.mutation({
            query: ({id}) => ({
                url: `/admin/contactus/status/${id}`,
                method: "PUT",
            }),
            invalidatesTags: ['Settings'],  
           }),
        }),
        
    });

    export const {
        useGetSettingsQuery,
        useAddSettingsMutation,
        useUpdateSettingsMutation,
        useGetContactUsQuery,
        useReplyContactUsQueryMutation,
        useChangePasswordMutation,
        useUpdateProfileMutation,
        useDeleteAccountMutation,
        useGetNotificationsQuery,
        useNotificationMarkAsReadMutation,
        useGetUserProfileQuery,
        useUpdateCompanyMutation,
        useUpdateSupportStatusMutation, 
    } = settingsApi;
